export const prefix = 'ds'

// storage key

export const LOGININFOKEY = `${prefix}_entry_token`
export const USERINFOKEY = `${prefix}_user_info`
export const OSSTOKEN = `${prefix}_oss_token`
export const ORGSKEY = `${prefix}_org_items`

export const PRODUCT_LINES = `${prefix}_product_lines`
export const SUB_PRODUCT_LINE_UUID = `${prefix}_sub_product_line_uuid`

// 产品线滚动位置
export const PRODUCT_LINE_SCROLL_TOP = `${prefix}_product_line_scroll_top`

export const PRODUCT_ITEMS_SCROLL_TOP = `${prefix}_product_items_scroll_top`


export const PRODUCT_DASHBOARD_SCROLL_TOP = `${prefix}_product_dashboard_scroll_top`

export const FIRMWARE_ITEMS_SCROLL_TOP = `${prefix}_firmware_items_scroll_top`

export const OTA_APPROVAL_SCROLL_TOP = `${prefix}_ota_approval_items_scroll_top`

export const FIRMWARE_DASHBOARD_SCROLL_TOP = `${prefix}_firmware_dashboard_scroll_top`

export const APK_ITEMS_SCROLL_TOP = `${prefix}_apk_items_scroll_top`

export const LANGS = `${prefix}_langs`
export const LANGS_CHECKS = `${prefix}_langs_checkIds`

/** 主题配置 */
export const APPTHEMECONFIG = `${prefix}_app_theme_config`

/** 当前域名根路径 */
export const ORIGIN_ROOT_URL = location.origin + (import.meta.env.VITE_ROUTE_BASE_PATH || '/')
/**
 * APP 下载页 URL 前缀
 */
export const DOWNLOAD_URL =
  (import.meta.env.VITE_APK_SHARE_BASE_URL || location.origin) + '/public/download/apk'
